import React, { useState, useEffect } from 'react';
import { User, Lock, Mail, Phone, UserPlus, MapPin, Map, Home, Pencil ,RefreshCw, Shield } from 'lucide-react';
import AuthFormContainer from './AuthFormContainer';

export default function ProfilePage({ user, setPage,onLogout  }) {
  const [formData, setFormData] = useState({vid: null,
    name: '', mobile: '', email: '', password: '', gst: '',
    address: '', city: '', state: '', pincode: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const API_BASE_URL = window._config?.apiBaseUrl || '';
  const DATABASE_KEY = window._config?.databaseKey || '';
//const usrId = user?.vid;
//const mail = user?.mail;
 const usrId = sessionStorage.getItem('vid');   
       const mail = sessionStorage.getItem('mail');
const [isEditing, setIsEditing] = useState(false);
 useEffect(() => {
  if (!user) return;

  const fetchProfile = async () => {
    try {
      setLoading(true);

     

      const res = await fetch(
        `${API_BASE_URL}/GetCustomer?UsrId=${usrId}&Mail=${encodeURIComponent(mail)}&databaseKey=${DATABASE_KEY}`
      );

      if (!res.ok) {
        throw new Error("Failed to fetch profile");
      }

      const data = await res.json();

      const info = data?.GetCustomerResult?.Table?.[0];

      if (info) {
        setFormData({
          vid: info.Vid,
          name: info.Vname || '',
          mobile: info.Mobile || '',
          email: info.Mail || '',
          password: info.fax || '',
          gst: info.GST || '',
          address: info.Address1 || '',
          city: info.City || '',
          state: info.State || '',
          pincode: info.Pincode || ''
        });
      } else {
        setError("Profile data not found.");
      }

    } catch (err) {
      console.error(err);
      setError('Failed to load profile.');
    } finally {
      setLoading(false);
    }
  };

  fetchProfile();
}, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleUpdate = async (e) => {
    e.preventDefault();
    const { name, mobile, email, address, city, state, pincode, gst, password } = formData;

    if (!name || !mobile || !email || !address || !city || !state || !pincode) {
      setError('Please fill in all required fields.');
      return;
    }

    if (!/^[0-9]{10}$/.test(mobile)) {
      setError('Mobile number must be exactly 10 digits.');
      return;
    }

    if (!/^[0-9]{6}$/.test(pincode)) {
      setError('Pincode must be exactly 6 digits.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Invalid email format.');
      return;
    }

    // Password optional for profile update
    if (password && !/^(?=.*[A-Za-z])(?=.*\d).{5,}$/.test(password)) {
      setError('Password must be at least 5 characters long and include both letters and numbers.');
      return;
    } const usrId = localStorage.getItem('vid');   

    const payload = {
       Vid: formData.vid,
      VCode: mobile,
      Vname: name,
      Address1: address,
      City: city,
      State: state,
      Country: 'N/A',  // or fetch/store
      Pincode: pincode,
      GST: gst,
      Phone: mobile,
      Mobile: mobile,
      Mail: email
    };

    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/UpdateCustomerDetails?databaseKey=${DATABASE_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();

      if (data?.UpdateCustomerDetails !== undefined) {
  alert("Profile updated successfully!");
  setIsEditing(false);
} else {
  setError("Update failed.");
}
    } catch (err) {
      console.error(err);
      setError('Update failed. Try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 py-10 overflow-hidden bg-gradient-to-br from-pink-100 via-rose-50 to-teal-100">

      {/* Floating Flowers */}
      <div className="absolute text-6xl top-10 left-10 animate-bounce opacity-20">🌸</div>
      <div className="absolute text-5xl bottom-20 right-16 animate-pulse opacity-20">🌷</div>
      <div className="absolute text-4xl top-1/3 right-10 animate-bounce opacity-20">🌺</div>

      <div className="w-full max-w-2xl p-8 transition-all duration-500 border shadow-2xl backdrop-blur-lg bg-white/70 rounded-3xl border-white/40">

        <div className="flex items-center justify-between mb-6">
  <h1 className="text-3xl font-bold text-teal-700">🌼 Your Profile</h1>

  <button
    type="button"
    onClick={() => setIsEditing(!isEditing)}
    className="p-2 transition bg-teal-100 rounded-full hover:bg-teal-200"
  >
    <Pencil className="w-5 h-5 text-teal-700" />
  </button>
</div>

        <form className="space-y-4" onSubmit={handleUpdate}>
          {error && (
            <p className="p-3 text-sm text-center text-red-600 bg-red-100 rounded-lg">{error}</p>
          )}

          <Input icon={<User />} name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" readOnly />
          <Input icon={<Mail />} name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" readOnly />
          <Input icon={<Phone />} name="mobile" value={formData.mobile} onChange={handleChange} placeholder="Mobile Number" maxLength={10} readOnly />
          <Input icon={<Lock />} name="password" type="password" value={formData.password} onChange={handleChange} placeholder="Password" readOnly />
          <Input icon={<UserPlus />} name="gst" value={formData.gst} onChange={handleChange} placeholder="GST Number" required={false}  readOnly={!isEditing} />
          <Input icon={<Home />} name="address" value={formData.address} onChange={handleChange} placeholder="Address"  readOnly={!isEditing} />
          <Input icon={<MapPin />} name="city" value={formData.city} onChange={handleChange} placeholder="City"   readOnly={!isEditing} />
          <Input icon={<Map />} name="state" value={formData.state} onChange={handleChange} placeholder="State"  readOnly={!isEditing}/>
          <Input icon={<MapPin />} name="pincode" value={formData.pincode} onChange={handleChange} placeholder="Pincode"  readOnly={!isEditing} maxLength={6} />

        {isEditing && (
  <button
    type="submit"
    disabled={loading}
    className="w-full py-3 font-semibold text-white transition duration-300 transform shadow-lg rounded-xl bg-gradient-to-r from-teal-500 to-rose-400 hover:scale-105 disabled:opacity-60"
  >
    {loading ? "Updating..." : "Update Profile 🌸"}
  </button>
)}

        </form>
        <div className="pt-6 mt-8 text-center border-t border-gray-200">
  <button
    type="button"
    onClick={() => {
      localStorage.removeItem("vid");
      localStorage.removeItem("mail");
      onLogout();         // clears user from App
      setPage("home");    // redirect to home
    }}
   className="w-full py-3 font-semibold text-white transition-all duration-300 shadow-md rounded-xl bg-gradient-to-r from-orange-400 to-rose-400 hover:from-orange-500 hover:to-rose-500"
  >
    Logout 🔓
  </button>
</div>
      </div>
    </div>
  );
}

// Reuse same Input component from Registration
const Input = ({ icon, name, value, onChange, placeholder, type = 'text', maxLength, required = true , readOnly = false}) => (
  <div className="relative">
    <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
     {React.cloneElement(icon, {
        className: `h-5 w-5 ${readOnly ? 'text-gray-400' : 'text-teal-600'}`
      })}
    </div>
    <input
      name={name}
      value={value}
      onChange={onChange}
      type={type}
      maxLength={maxLength}
      required={required}
       readOnly={readOnly}
      className="block w-full px-3 py-3 pl-12 text-gray-900 placeholder-gray-500 transition-shadow duration-300 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
      placeholder={placeholder}
    />
  </div>
);
